import * as React from 'react';

import { IModuleProps } from '@msdyn365-commerce-modules/utilities';
import { IWarrantyOption } from '../../actions/DataServiceEntities.g';
import { ProductWarrantyStateInput } from '../../actions/state-data-actions/product-warranty-state.action';
import { IProductWarrantyComponentProps } from '../../components/product-warranty/product-warranty.props';
import { IProductWarrantyData } from './product-warranty.data';
import { IProductWarrantyProps } from './product-warranty.props.autogenerated';
import classnames from 'classnames';
import { getSelectedProductIdFromActionInput } from '../../utilities/utils';

export interface IProductWarrantyViewProps extends IProductWarrantyProps<IProductWarrantyData> {
    moduleProps: IModuleProps;
    productWarrantyComponentProps: IProductWarrantyComponentProps;
}

export interface IProductWarrantyState {
    error: any;
    isLoaded: boolean | undefined;
    selectedWarrantyOption: IWarrantyOption | undefined;
    isSelectWarrantyDisabled: boolean | undefined;
}

export interface IPropText {
    imageSrc: string;
    imageAltText: string;
    textTitle: string;
    textSubtitle: string;
    textNoSelection: string;
    textPriceBridge: string;
    textResource: string;
}

/**
 *
 * ProductWarranty component
 * @extends {React.PureComponent<IProductWarrantyProps<IProductWarrantyData>>}
 */
class ProductWarranty extends React.PureComponent<IProductWarrantyProps<IProductWarrantyData>, IProductWarrantyState> {
    constructor(props: IProductWarrantyProps<IProductWarrantyData>) {
        super(props);
        this.state = {
            error: null,
            isLoaded: false,
            selectedWarrantyOption: undefined,
            isSelectWarrantyDisabled: false
        };
        this.formSubmit = this.formSubmit.bind(this);
    }

    public _setSelectedWarrantyOption = (selectedWarrantyOption: IWarrantyOption | undefined) => {
        this.setState({
            selectedWarrantyOption: selectedWarrantyOption
        });
        const productId =
            getSelectedProductIdFromActionInput(this.props.context.actionContext) ?? selectedWarrantyOption?.WarrantableProduct;
        if (productId) {
            this.props.context.actionContext.update(new ProductWarrantyStateInput(+productId), selectedWarrantyOption);
        }
    };

    public _setSelectWarrantyDisabled = (isDisabled: boolean) => {
        this.setState({
            isSelectWarrantyDisabled: isDisabled
        });
    };

    public formSubmit(event: { preventDefault: () => void }) {
        event.preventDefault();
    }

    public componentDidMount() {
        this.setState({
            isLoaded: true
        });
    }

    public render(): JSX.Element | null {
        const productQuantity = this.props?.data?.productQuantityState?.result;
        let selectWarrantyDisabled = this.state.isSelectWarrantyDisabled;
        if (
            this.props?.context?.app?.config?.disableWarrantyOnMultipleQuantityProducts &&
            this.props?.data?.productQuantityState?.result &&
            this.props?.data?.productQuantityState?.result > 1
        ) {
            selectWarrantyDisabled = true;
        }
        const props: IProductWarrantyViewProps = {
            ...this.props,
            moduleProps: {
                moduleProps: this.props,
                className: classnames('mmx-product-warranty-module', this.props.config.className)
            },
            productWarrantyComponentProps: {
                design: this.props.context.app.config.productWarrantySelectorDesign,
                className: 'mmx-product-warranty-module',
                productWarranties: this.props.data.productWarranties[0].result,
                warrantyIcons: this.props.data.warrantyIcons?.result,
                isSelectWarrantyDisabled: selectWarrantyDisabled,
                productQuantity: productQuantity,
                learnMoreLink: this.props.context.app.config.productWarrantyLearnMoreLink,
                onSelectWarrantyOption: this._setSelectedWarrantyOption
            }
        };
        return this.props.renderView(props) as React.ReactElement;
    }
}

export default ProductWarranty;
